import { Lookup } from "./lookup.model";

export class AgentGroup extends Lookup {
    override id: string;
    type: number;
    casId: string;
    organizationLevelId: string;
    organizationLevelName?: string;
    addedToMySite: boolean;
    addedAtSelectedOrgLevel?: boolean;
    agentIds?: string[];
    agentGroupSearchField?: string;
    updatedByUserId?: string;
    updatedByUserName?: string;
    dateCreated?: string;
    dateUpdated?: string;
    deletedByUserId?: string | null;
    deletedByUserName?: string;
    deletedDate?: string | null;
    isDeleted?: boolean;
}

export class AgentGroupRecordHistory extends AgentGroup {
    entityId: string;
    reason?: string;
    changedFields?: string;
    changedFieldsArray?: string[];
    changedFieldSet?: Set<string>;
    dateUpdatedDisplay?: string;
}
